import { useMediaQuery } from '@material-ui/core';

export const CheckMobileHook = () => {
  const isMobile = useMediaQuery('(max-width:1023px)');

  return {
    isMobile,
  };
};
